/**
 * Reset Button Component
 *
 * A universal reset button component that can be used by any control group.
 * Follows DRY principle by providing a single, reusable reset functionality.
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

export { ResetButton } from './reset-button';
export type { ResetButtonProps } from './types';
